export default __webpack_public_path__ + "media/images/dividers/inverse-blue-rip-dd7a334af2cb4533b573aa90070683b1.svg";